import script from "./MarkdownText.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownText.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownText.vue?vue&type=style&index=0&id=56a984ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a984ec"]])

export default __exports__